module.exports = __webpack_public_path__ + "img/JUST.1a7d368c.jpeg";